<div class="fixed-top">
  <header style="background-image:url(/Images/bg.gif)">
    <a class="logo" href="/">
      <img src="/Images/saiki_logo.png" />
    </a>
  </header>
  <nav class="navbar navbar-default justify-content-end flex-nowrap">
    <div *ngIf="isVacantBedsReferenceUser">
      <a class="btn btn-danger btn-danger-gradient" routerLink="/disaster">災　害　時</a>
     </div>
  </nav>
</div>

<div class="container body-content">
  <ngx-toasta></ngx-toasta>
  <router-outlet></router-outlet>
</div>
<footer class="fixed-bottom">
  <hr />

  <h6 align="center">Copyrightc {{currentYear}} Saiki Medical Association. All rights reserved.</h6>
</footer>
